module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("注册渠道管理")])], 1)], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "animated": false
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "渠道",
      "name": "channel"
    }
  }, [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道参数"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确匹配"
    },
    model: {
      value: (_vm.queryParam.param),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "param", $$v)
      },
      expression: "queryParam.param"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "中介",
      "name": "agency"
    }
  }, [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchAgency.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.id),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "id", $$v)
      },
      expression: "agencyQuery.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.name),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "name", $$v)
      },
      expression: "agencyQuery.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "账号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.account),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "account", $$v)
      },
      expression: "agencyQuery.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.agencyQuery.status),
      callback: function($$v) {
        _vm.$set(_vm.agencyQuery, "status", $$v)
      },
      expression: "agencyQuery.status"
    }
  }, _vm._l((_vm.$constant.teacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.agencySearchLoading
    },
    on: {
      "click": _vm.searchAgency
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAgencyAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.agencyColumns,
      "data": _vm.agencyList,
      "loading": _vm.agencyTableLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.agencyTotal,
      "current": _vm.agencyQuery.pageIndex,
      "page-size": _vm.agencyQuery.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onAgencyPageChange,
      "on-page-size-change": _vm.onAgencyPageSizeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑渠道' : '新增渠道'
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "channelForm",
    attrs: {
      "label-width": 90,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道名称",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "渠道参数",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.formData.param === '转介绍' && !!_vm.formData.id
    },
    model: {
      value: (_vm.formData.param),
      callback: function($$v) {
        _vm.$set(_vm.formData, "param", $$v)
      },
      expression: "formData.param"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), (_vm.showTchInfoModal) ? _c('tch-info-modal', {
    key: 'agency-modal-' + (_vm.agencyTchId || 'new'),
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.agencyTchId,
      "addType": _vm.agencyAddType,
      "successCallback": _vm.onAgencySaved
    },
    on: {
      "on-close": _vm.onAgencyModalClose
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-988ad334","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchRegChannelList.vue
// module id = 1910
// module chunks = 8